import { render, staticRenderFns } from "./ShiftSalesTipsDialog.vue?vue&type=template&id=7565c0f2&scoped=true&"
import script from "./ShiftSalesTipsDialog.vue?vue&type=script&lang=js&"
export * from "./ShiftSalesTipsDialog.vue?vue&type=script&lang=js&"
import style0 from "./ShiftSalesTipsDialog.vue?vue&type=style&index=0&id=7565c0f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7565c0f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog,VSpacer})
